import { useQuery } from "@tanstack/react-query";
import { Bot } from "lucide-react";
import { useTranslation } from "react-i18next";
import { listAgentsOptions } from "@/api";
import { Page } from "@/components/Page";
import { SpaceItemsList } from "./SpaceItemsList";
import { useSettingsSpace } from "./useSpaceSettings";

export function AgentsSection() {
  const { t } = useTranslation("spaces", { keyPrefix: "settings.agents" });
  const space = useSettingsSpace();
  const agents = useQuery({
    ...listAgentsOptions({ query: { page_size: 100 } }),
    select: (r) => r.data.map((a) => ({ uuid: a.uuid, name: a.name, description: a.description })),
  });
  return (
    <Page title={t("title")}>
      <SpaceItemsList
        spaceUuid={space.uuid}
        type="agent"
        title={t("title")}
        addLabel={t("add")}
        addTitle={t("addTitle")}
        emptyHint={t("empty")}
        icon={<Bot size={18} />}
        openPath={(uuid) => `/build/agents/${uuid}`}
        options={agents}
        showTitle={false}
      />
    </Page>
  );
}
